<template>
	<ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
		@current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
		<template slot="filters">
			<el-form-item label="管理员名称" prop="keywords">
				<el-input v-model="query.keywords" placeholder="请输入管理员名称" clearable
					@keyup.enter.native="handleSearch" />
			</el-form-item>
		</template>
		<template slot="btns" v-if="permission('/permission/admin/list/add')">
			<el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
				新增管理员
			</el-button>
		</template>
		<template slot="columns">
			<el-table-column label="ID" align="center" prop="id" />
			<el-table-column label="管理员名称" align="center" prop="nikeName" />
			<el-table-column label="管理员账号" align="center" prop="username" />
			<el-table-column label="角色" align="center" prop="roleNames" />
			<el-table-column label="手机号" align="center" prop="phone" />
			<el-table-column label="最后登录时间" align="center" prop="createTime">
				<template slot-scope="{ row }">
					{{ formatDate(row.createTime) }}
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center" width="180"
				v-if="permission('/permission/admin/list/password') || permission('/permission/admin/list/edit') || permission('/permission/admin/list/delete')">
				<template slot-scope="{ row }">
					<el-link v-if="permission('/permission/admin/list/password')" style="margin-right: 10px"
						:underline="false" type="primary" @click="handleUpdatePassword(row)">
						修改密码
					</el-link>
					<el-link v-if="permission('/permission/admin/list/edit')" style="margin-right: 10px"
						:underline="false" type="primary" @click="handleEdit(row)">
						编辑
					</el-link>
					<el-link v-if="permission('/permission/admin/list/delete')" :underline="false" type="danger"
						@click="handleDel(row)">
						删除
					</el-link>
				</template>
			</el-table-column>
		</template>
		<el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%">
			<el-form :model="form" :rules="rules" ref="form" label-width="100px">
				<!-- <el-form-item label="旧密码" prop="oldPassword">
					<el-input type="password" v-model="form.oldPassword" placeholder="请输入旧密码" show-password
						autocomplete="new-password"></el-input>
				</el-form-item> -->
				<el-form-item label="新密码" prop="newPassword">
					<el-input type="password" v-model="form.newPassword" placeholder="请输入新密码" show-password
						autocomplete="new-password"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="newConfirmPassword">
					<el-input type="password" v-model="form.newConfirmPassword" placeholder="请输入确认密码" show-password
						autocomplete="new-password"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="handleUpdatePasswordConfirm">确定</el-button>
			</div>
		</el-dialog>
	</ListPage>
</template>

<script>
import { page, del, updatePassword } from "@/api/permission/admin";
import listMixin from '@/mixins/list';

export default {
	data() {
		return {
			// 查询参数
			query: {
				keywords: "",
			},
			dialogVisible: false,
			form: {
				oldPassword: "",
				newPassword: "",
				newConfirmPassword: "",
			},
			rules: {
				// oldPassword: [{ required: true, message: '请输入旧密码' }],
				newPassword: [{ required: true, message: '请输入新密码' }],
				newConfirmPassword: [{ required: true, message: '请输入确认密码' }],
			}
		};
	},
	mixins: [listMixin],
	methods: {
		search() {
			this.loading = true;
			const params = {
				...this.query,
			};
			page(params).then(({ code, result, message }) => {
				if (code == 200) {
					this.tableData = result.records;
					this.total = result.total;
				} else {
					this.$message.error(message);
				}
				this.loading = false;
			});
		},
		handleAdd() {
			this.$router.push("/permission/admin/form");
		},
		handleEdit(row) {
			this.$router.push({ path: "/permission/admin/form", query: { id: row.id } });
		},
		handleDel(row) {
			this.$confirm("是否删除该管理员?", "提示", {
				type: "warning",
			})
				.then(() => {
					del({ id: row.id }).then(({ code, message }) => {
						if (code == 200) {
							this.$message.success("删除成功");
							this.search();
						} else {
							this.$message.error(message);
						}
					});
				})
				.catch(() => { });
		},
		handleUpdatePassword(row) {
			this.dialogVisible = true;
		},
		handleUpdatePasswordConfirm() {
			this.$refs.form.validate(valid => {
				if (!valid) return;
				if (this.form.newPassword !== this.form.newConfirmPassword) {
					this.$message.error("新密码与确认密码不一致");
					return;
				}
				updatePassword(this.form).then(({ code, message }) => {
					if (code == 200) {
						this.$message.success("修改密码成功");
						this.dialogVisible = false;
						this.search();
					} else {
						this.$message.error(message);
					}
				});
			});
		}
	},
};
</script>